<label>Qassatly Payment Plans</label>

<mat-form-field appearance="outline"
                #select
                style="width:100%;">
  <mat-select formControlName="formControlRef" [compareWith]="comparer" [value]="formControlRef.value" multiple>
    <mat-option *ngFor="let plan of paymentPlans" [value]="plan">{{ plan.name }}</mat-option>
  </mat-select>
</mat-form-field>
